import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-track',
  templateUrl: './track.component.html',
  styleUrls: ['./track.component.scss']
})
export class TrackComponent implements OnInit {

  id: string

constructor(private router: Router) { }

  ngOnInit() {
  }

  submit() {
    if(this.id && this.id !== "") {
      this.router.navigate(["track/result"], {queryParams: {id: this.id}})
    }
  }

}
